'use client';
import { icons } from 'lucide-react';

/** lucide 아이콘 — 이름 문자열로 동적 렌더(관리자와 같은 방식·같은 lucide 버전) */
export function Icon({ name, size = 18, className }: { name: string; size?: number; className?: string }) {
  const pascal = name
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join('');
  const C = (icons as Record<string, React.FC<{ size?: number; className?: string }>>)[pascal];
  // 이름이 틀리면 조용히 사라진다 — 개발 중에는 콘솔로 알린다(관리자에서 겪은 lucide 개명 사고)
  if (!C) {
    if (process.env.NODE_ENV === 'development') console.warn(`[Icon] 없는 아이콘 이름: ${name} (lucide ${pascal})`);
    return null;
  }
  return <C size={size} className={className} />;
}
